/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HomeownershipLastLookAnswer } from './HomeownershipLastLookAnswer';
import {
    HomeownershipLastLookAnswerFromJSON,
    HomeownershipLastLookAnswerFromJSONTyped,
    HomeownershipLastLookAnswerToJSON,
} from './HomeownershipLastLookAnswer';

/**
 * 
 * @export
 * @interface HomeownershipLastLookBlock
 */
export interface HomeownershipLastLookBlock {
    /**
     * 
     * @type {string}
     * @memberof HomeownershipLastLookBlock
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipLastLookBlock
     */
    matchPrice?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipLastLookBlock
     */
    windowEndsDate?: string;
    /**
     * 
     * @type {number}
     * @memberof HomeownershipLastLookBlock
     */
    windowDays: number;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipLastLookBlock
     */
    windowBasis: HomeownershipLastLookBlockWindowBasisEnum;
    /**
     * 
     * @type {HomeownershipLastLookAnswer}
     * @memberof HomeownershipLastLookBlock
     */
    answer?: HomeownershipLastLookAnswer;
    /**
     * 
     * @type {Date}
     * @memberof HomeownershipLastLookBlock
     */
    answeredAt?: Date;
}


/**
 * @export
 */
export const HomeownershipLastLookBlockWindowBasisEnum = {
    Business: 'business',
    Calendar: 'calendar'
} as const;
export type HomeownershipLastLookBlockWindowBasisEnum = typeof HomeownershipLastLookBlockWindowBasisEnum[keyof typeof HomeownershipLastLookBlockWindowBasisEnum];


/**
 * Check if a given object implements the HomeownershipLastLookBlock interface.
 */
export function instanceOfHomeownershipLastLookBlock(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "windowDays" in value;
    isInstance = isInstance && "windowBasis" in value;

    return isInstance;
}

export function HomeownershipLastLookBlockFromJSON(json: any): HomeownershipLastLookBlock {
    return HomeownershipLastLookBlockFromJSONTyped(json, false);
}

export function HomeownershipLastLookBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipLastLookBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'matchPrice': !exists(json, 'match_price') ? undefined : json['match_price'],
        'windowEndsDate': !exists(json, 'window_ends_date') ? undefined : json['window_ends_date'],
        'windowDays': json['window_days'],
        'windowBasis': json['window_basis'],
        'answer': !exists(json, 'answer') ? undefined : HomeownershipLastLookAnswerFromJSON(json['answer']),
        'answeredAt': !exists(json, 'answered_at') ? undefined : (new Date(json['answered_at'])),
    };
}

export function HomeownershipLastLookBlockToJSON(value?: HomeownershipLastLookBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'match_price': value.matchPrice,
        'window_ends_date': value.windowEndsDate,
        'window_days': value.windowDays,
        'window_basis': value.windowBasis,
        'answer': HomeownershipLastLookAnswerToJSON(value.answer),
        'answered_at': value.answeredAt === undefined ? undefined : (value.answeredAt.toISOString()),
    };
}

